import { render, staticRenderFns } from "./FactOrDimensionTable.vue?vue&type=template&id=40ef8492&%3Akey=currentKey&"
import script from "./FactOrDimensionTable.vue?vue&type=script&lang=js&"
export * from "./FactOrDimensionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports